import api from "../api";

export const getAllUsages = async (params?: Record<string, any>) => {
  const { data } = await api.get("rightFractionHistories/usages", { params });

  return data.usages;
};
